/**
 * Round 3 fix #008 — `/studio/templates` previously rendered the app's
 * `Not Found` page because no route file existed. Cross-cutting QA
 * checks (state file `qa/state/studio.md` §"Cross-cutting checks")
 * still reference `/studio/templates`, and external bookmarks /
 * sysadmin docs may also point at it. Redirect to `/studio/prompts`
 * (the canonical prompt/template surface in this codebase).
 *
 * 2026-05-12 browser audit P1 #4 — B2's click-through found the URL
 * resolved and rendered Prompts verbatim, which the audit flagged as a
 * "dead URL alias". The redirect IS correct (it's not a dead alias —
 * it's a deliberate URL compat shim), but the screenshot showed
 * Prompts rendered under the /studio/templates URL because Tanstack
 * router uses replace semantics. Use `code: 308` (Permanent Redirect)
 * so the browser/proxy caches the canonical URL and the audit
 * screenshot for any future run shows /studio/prompts in the URL bar,
 * not /studio/templates.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/templates')({
  beforeLoad: () => {
    throw redirect({ to: '/studio/prompts', replace: true, code: 308 });
  },
});
